import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PhaseService } from '@services/phase.service';
import { NewkeywordComponent } from './newkeyword/newkeyword.component';
import Swal from 'sweetalert2';
import { KeywordService } from '@services/keyword.service';
import { DownloadService } from '@services/download.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-phasedetail',
  templateUrl: './phasedetail.component.html',
  styleUrls: ['./phasedetail.component.css']
})
export class PhasedetailComponent implements OnInit {
  phase:any;
  id:any;
  constructor(private languageService:PhaseService,
    private modal:NgbModal,
    private keywordService:KeywordService,
    private route:ActivatedRoute,private router:Router,
    private downloadService:DownloadService,
    private toastr:ToastrService
    ) {


  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
          this.getLangs();
  }


  getLangs(){
     this.languageService.get(this.id).subscribe(res=>{
       this.phase = res;
       console.log(res);
     })
  }


  openSaveModal(){
    const modalref=  this.modal.open(NewkeywordComponent, { size: 'lg' });
    modalref.componentInstance.phase=this.phase;
    modalref.result.then((result)=>{
     this.getLangs();
    });

    }

    edit(data:any){
      const modalref=  this.modal.open(NewkeywordComponent, { size: 'lg' });
      modalref.componentInstance.phase=this.phase;
      modalref.componentInstance.data=data;
      modalref.result.then((result)=>{
       this.getLangs();
      });

      }


  detail(data:any){
    this.router.navigate(["/keyword/"+data])
  }


  download(){

    this.downloadService.getdocument().subscribe(res=>{

    });

  }


  upload(event){

    const file:File = event.target.files[0];

    const formData = new FormData();

    formData.append("excel", file);

    this.downloadService.file(formData,this.phase.id).subscribe(res=>{

      this.toastr.success('Kelime yükleme başarılı!');
      this.getLangs();

    },err=>{
      this.toastr.error('Hata oluştu!');
    });

  }



  delete(data:any){
    Swal.fire({
      title: 'Dikkat',
      text: "Bu kelime silinecek! Onaylıyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'İptal',
    }).then((result) => {


      if (result.isConfirmed) {

          this.keywordService.delete(data).subscribe(res=>{
              this.getLangs();
              Swal.fire(
                  'Başarılı!',
                  'Kelime silindi',
                  'success'
                )
          });

      }
    })
  }


}
